/*
 * @Description:
 * @Version: 1.0
 * @Author: zhuangyuan
 * @Date: 2022-01-13 15:38:53
 * @LastEditors: zhuangyuan
 * @LastEditTime: 2022-02-24 16:00:39
 * @FilePath: \cqliving-live-h5\src\store\index.ts
 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const stateOption: IIndexObject = {
  token: "",
  appId: "",
  sessionId: "",
  // 当前选择的主持人
  checkedHosts: [],
  // 关闭浏览量
  hideDetailViewCount: 1,
  videoFullScreen: false,

  // appId
  appIdFromUA: 0,
  isOpenWxBindPhone: false,
  openId: 0,
  liveShare: null
};
export default new Vuex.Store({
  state: stateOption,
  mutations: {
    SET_STATE(state, obj) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          (state as IIndexObject)[key] = obj[key];
        }
      }
    }
  },
  actions: {},
  modules: {}
});
